import React, { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { Box, ListItem, ListItemText, Tooltip, useTheme } from '@mui/material';
import { TextFieldCDS } from 'app/shared/componentsRestyled/coreDesignSystem/form';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { getScrollStyles } from 'styles/scrollbar.styles';

import { selectEmailSnippetsSortedList } from 'store/companies/selectors';

import { ActivitiesTestIds } from '../../../Activities.testIds';
import { getStyles } from '../../EmailCreationModal.styles';

const listItemClasses = { primary: 'truncate' };

const SnippetsPopover = ({ onSelectSnippet, isLoading = false }) => {
  const theme = useTheme();
  const classes = getStyles(theme);
  const scrollClasses = getScrollStyles(theme);

  const snippetListSx = useMemo(
    () => [classes.snippetList, scrollClasses.scroll],
    [classes.snippetList, scrollClasses.scroll],
  );

  const snippets = useSelector(selectEmailSnippetsSortedList);

  const [searchValue, setSearchValue] = useState();

  const onSearchChange = useCallback(e => {
    e.preventDefault();
    setSearchValue(e.currentTarget.value);
  }, []);

  const filteredSnippets = useMemo(
    () =>
      searchValue
        ? snippets.filter(snippet => _.toLower(snippet.name)?.includes(_.toLower(searchValue)))
        : snippets,
    [searchValue, snippets],
  );

  return (
    <>
      <TextFieldCDS
        autoFocus
        className="mt-24 w-full"
        dataTestId={ActivitiesTestIds.SNIPPETS_SEARCH_INPUT}
        disabled={isLoading}
        label="Snippets"
        name="snippetsSearch"
        placeholder="Search Snippets"
        value={searchValue}
        variant="outlined"
        onChange={onSearchChange}
      />
      <Box sx={snippetListSx}>
        {filteredSnippets.map((snippet, index) => (
          <ListItem
            button
            dense
            data-label={snippet.name}
            data-snippet-id={snippet.id}
            data-title={snippet.name}
            disabled={isLoading}
            key={index}
            onClick={onSelectSnippet}
          >
            <Tooltip title={snippet.name}>
              <ListItemText
                classes={listItemClasses}
                primary={snippet.name}
                secondary={snippet.securityGroupAssociation.name}
              />
            </Tooltip>
          </ListItem>
        ))}
      </Box>
    </>
  );
};

SnippetsPopover.propTypes = {
  onSelectSnippet: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default SnippetsPopover;
